import React from "react";
import { TextInput } from "@mantine/core";
import { Controller, useFormContext } from "react-hook-form";

const RHFPhoneInput = ({
  name,
  rules,
  defaultValue = "",
  maxLength = 10,
  onValueChange,
  ...props
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field, fieldState: { error } }) => {
        const handleChange = (event) => {
          let value = event.currentTarget.value;

          // Keep only digits
          value = value.replace(/\D/g, "");

          if (maxLength) {
            value = value.slice(0, maxLength);
          }

          field.onChange(value);

          if (onValueChange) {
            onValueChange(value);
          }
        };

        const handlePaste = (event) => {
          event.preventDefault();

          let value = event.clipboardData.getData("text");

          value = value.replace(/\D/g, "");

          if (maxLength) {
            value = value.slice(0, maxLength);
          }

          field.onChange(value);

          if (onValueChange) {
            onValueChange(value);
          }
        };

        return (
          <TextInput
            {...props}
            {...field}
            value={field.value ?? ""}
            error={error?.message}
            inputMode="numeric"
            autoComplete="tel"
            onChange={handleChange}
            onPaste={handlePaste}
             styles={{
              label: {
              fontSize: "16px",lineHeight: "24px",fontWeight: 400,color: "#222222",marginBottom:'8px'
            }}}
          />
        );
      }}
    />
  );
};

export default RHFPhoneInput;